'use strict';

exports.__esModule = true;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _parseInt = require('babel-runtime/core-js/number/parse-int');

var _parseInt2 = _interopRequireDefault(_parseInt);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _debounce2 = require('lodash/debounce');

var _debounce3 = _interopRequireDefault(_debounce2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _doctifyUtils = require('doctify-utils');

var _reduxSimpleAuth = require('redux-simple-auth');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

var _doctifyGlobalRedux = require('doctify-global-redux');

var _doctifyGlobalRedux2 = _interopRequireDefault(_doctifyGlobalRedux);

var _pageActions = require('../actions/page-actions');

var pageActions = _interopRequireWildcard(_pageActions);

var _resultsActions = require('../actions/results-actions');

var _advancedSearchBarActions = require('../actions/advanced-search-bar-actions');

var _searchResults = require('../../../search-results');

var _loadingDots = require('loading-dots');

var _googleMaps = require('./google-maps');

var _googleMaps2 = _interopRequireDefault(_googleMaps);

var _advancedSearchBar = require('../../../advanced-search-bar');

var _reactPlacesAutocomplete = require('react-places-autocomplete');

var _popularSpecialistSearches = require('../../../popular-specialist-searches');

var _headHelmet = require('../../../head-helmet');

var _dropdowns = require('../transformers/dropdowns');

var _transformSearchKeywordItemsForDropdown = require('../../../../src/client/utils/transformers/transformSearchKeywordItemsForDropdown');

var _transformListingsForExpandedDropdown = require('../../../../src/client/utils/transformers/transformListingsForExpandedDropdown');

var _utils = require('../utils/utils');

var _loaders = require('../utils/loaders');

var _constants = require('../utils/constants');

var _data = require('../data');

var defaultData = _interopRequireWildcard(_data);

var _constants2 = require('../../../../src/client/utils/constants');

var _showSearchInputRequiredMessage = require('../../../../src/client/utils/show-search-input-required-message');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
	Redux and router and auth stuff
**/

/**
 Constants
 **/

/**
 Types
 **/

/**
 Helpers
 **/

/**
 Components
 **/

/**
 Custom redux
 **/

/**
 Utilities
 **/
/**
 Basics
 **/
var searchPageLoader = new _doctifyUtils.PageLoader(_loaders.loaders);

/**
	Actions
**/

/**
 loaders
 **/

/**
 transformers
 **/
var globalActions = _doctifyGlobalRedux2.default.globalActions;
var ListingsActions = globalActions.ListingsActions;
var AutocompleteActions = globalActions.AutocompleteActions;
var MobileSearchMenuActions = globalActions.MobileSearchMenuActions;

/**
	set up the IntlProvider
**/
var locale = 'en';
var messages = require('../../src/lang/' + locale + '.json');
var localeData = require('react-intl/locale-data/' + locale);

(0, _reactIntl.addLocaleData)(localeData);
/**
	Dynamic styles
**/
// import { fadeIn } from 'react-animations';
// import { StyleSheet, css } from 'aphrodite';
// const dynamicStyles = StyleSheet.create({
// 	fadeIn: {
// 		animationName: fadeIn,
// 		animationDuration: '1s'
// 	}
// });

/**
	Now the Component
**/

var SearchPage = function (_React$Component) {
  (0, _inherits3.default)(SearchPage, _React$Component);

  function SearchPage(props) {
    (0, _classCallCheck3.default)(this, SearchPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

    var searchBarHolder = null;
    _this.searchBarHolder = searchBarHolder;
    return _this;
  }

  SearchPage.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var props = this.props;

    props.pageActions.updateSearchBarHolderHeight(this.searchBarHolder && this.searchBarHolder.clientHeight);

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', (0, _debounce3.default)(function () {
        setTimeout(function () {
          props.pageActions.updateSearchBarHolderHeight(_this2.searchBarHolder && _this2.searchBarHolder.clientHeight);
        });
      }), 500);
    }
  };

  SearchPage.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.page.searchBarHolderHeight && this.searchBarHolder) {
      prevProps.pageActions.updateSearchBarHolderHeight(this.searchBarHolder && this.searchBarHolder.clientHeight);
    }
  };

  SearchPage.prototype.render = function render() {
    var _this3 = this;

    var props = this.props;

    props.init(props);
    /**
     here we check if the page has been loaded, and that on client side before
     starting the search
     **/

    if (typeof window !== 'undefined' && props.page.pageLoaded) {

      props.mapUrlToProps(props);
    }

    var pagePaddingTop = props.app.headerHeight + (typeof window !== 'undefined' && window.innerWidth >= 768 && props.page.searchBarHolderHeight || 0);

    var autocompleteSearchItems = props.advancedSearchBar.text && props.advancedSearchBar.text.length >= _constants.MIN_AUTOCOMPLETE_LENGTH && props.advancedSearchBar.keywordItems && (0, _transformSearchKeywordItemsForDropdown.transformSearchKeywordItemsForDropdown)(props.listings, props.advancedSearchBar.keywordItems) || (0, _utils.searchType)(props.location) === _constants.SCANS && (0, _dropdowns.transformDropdownTreatmentGroups)(props.listings.scansTreatmentGroups) || (0, _utils.searchType)(props.location) === _constants.HEALTH_CHECK && (0, _dropdowns.transformDropdownTreatmentGroups)(props.listings.healthChecksTreatmentGroups) || (0, _transformListingsForExpandedDropdown.transformListingsForExpandedDropdown)(props.listings, _constants2.requiredTopLevelSpecialtiesNames);
    var isSpecialtiesAvailable = autocompleteSearchItems.some(function (item) {
      return item.type === 'specialty' || item.keyword_type === 'specialty';
    });

    return _react2.default.createElement(
      _reactIntl.IntlProvider,
      { locale: locale, messages: messages },
      _react2.default.createElement(
        'div',
        { className: _style2.default.searchPage + ' ' + (props.location && props.location.query && (props.location.query.search_type === _constants.SCANS || props.location.query.search_type === _constants.HEALTH_CHECK) ? _style2.default.scans : null),
          id: _style2.default.searchPage,
          style: { paddingTop: pagePaddingTop }
        },
        _react2.default.createElement(_headHelmet.HeadHelmet, {
          pageTitle: 'Specialist Doctors within ' + (props.advancedSearchBar && props.advancedSearchBar.selectedWithin && props.advancedSearchBar.selectedWithin.value || '50') + ' miles of ' + (props.advancedSearchBar && props.advancedSearchBar.selectedLocation && props.advancedSearchBar.selectedLocation.name || 'London') + '.',
          pageContent: 'Specialist Doctors within ' + (props.advancedSearchBar && props.advancedSearchBar.selectedWithin && props.advancedSearchBar.selectedWithin.value || '50') + ' miles of ' + (props.advancedSearchBar && props.advancedSearchBar.selectedLocation && props.advancedSearchBar.selectedLocation.name || 'London') + '. Find the best doctors and health specialists near you. Book doctor appointments online.',
          pageImage: '' + (0, _doctifyUtils.getResourcePath)('/img/logo-dark.svg'),
          pagePath: (0, _doctifyUtils.getResourcePath)('/')
        }),
        (props.location && props.location.query && props.location.query.search_type || props.results.searchResults && props.results.searchResults.length) && _react2.default.createElement(
          'div',
          { className: _style2.default.searchBarHolder + ' ' + (props.location && props.location.query && (props.location.query.search_type === _constants.SCANS || props.location.query.search_type === _constants.HEALTH_CHECK) ? _style2.default.scans : null),
            style: { top: props.app.headerHeight + 'px' },
            ref: function ref(elem) {
              return _this3.searchBarHolder = elem;
            }
          },
          _react2.default.createElement(_advancedSearchBar.AdvancedSearchBar, (0, _extends3.default)({}, props.advancedSearchBar, props.advancedSearchBarActions, {

            page: props.page,
            pageActions: props.pageActions,
            listings: props.listings,

            loadingResults: props.results.loadingResults,
            insurerItems: (0, _dropdowns.transformDropdownInsurer)(props.listings && props.listings.insurers),
            languageItems: (0, _dropdowns.transformDropdownLanguage)(props.listings && props.listings.languages),
            keywordItems: autocompleteSearchItems,

            selectedTimeFrame: props.advancedSearchBar.selectedTimeFrame || props.advancedSearchBar.selectedDates && props.advancedSearchBar.selectedDates.length === 2 && (props.advancedSearchBar.selectedDates[1].isSame(new _moment2.default.utc().add(14, 'days'), 'day') && 'twoWeeks' || props.advancedSearchBar.selectedDates[1].isSame(new _moment2.default.utc().add(7, 'days'), 'day') && 'thisWeek' || props.advancedSearchBar.selectedDates[0].isSame(new _moment2.default.utc(), 'day') && 'today' || props.advancedSearchBar.selectedDates[0].isSame(new _moment2.default.utc().add(1, 'day'), 'day' && 'tomorrow')),
            selectedKeyword: props.advancedSearchBar.selectedKeyword || { name: props.advancedSearchBar.text || '' },

            resultCount: props.results.totalResults,
            selectedDate: props.advancedSearchBar.selectedDates && props.advancedSearchBar.selectedDates[0] || new _moment2.default.utc().add(2, 'days'),
            searchType: props.location && props.location.query && props.location.query.search_type ? props.location.query.search_type : _constants.APPOINTMENTS,

            onUpdateClicked: function onUpdateClicked() {

              var search = function search(newAdvancedSearchBarProps) {
                if (!props.advancedSearchBar.selectedInsurer) {
                  props.page.insurersDropdownElem && props.page.insurersDropdownElem.openDropdown();
                } else if (props.advancedSearchBar.text && (!props.advancedSearchBar.selectedKeyword || props.advancedSearchBar.text !== props.advancedSearchBar.selectedKeyword.name)) {
                  (0, _showSearchInputRequiredMessage.showSearchInputRequiredMessage)(props.page.searchItemDropdownElem.inputField, isSpecialtiesAvailable);
                } else {
                  props.pageActions.updateInsurersDropdownElem(null);
                  props.pageActions.updateSearchItemDropdownElem(null);
                  props.launchSearch((0, _assign2.default)({}, props.advancedSearchBar, newAdvancedSearchBarProps, {
                    route: props.route,
                    listings: props.listings,
                    autocomplete: props.autocomplete
                  }));
                }
              };

              //If user just typed something in "location" field without choosing an item in dropdown, we either choose first item from list, or removing text from input field, if no locations were found
              var _props$advancedSearch = props.advancedSearchBar,
                  locationInputField = _props$advancedSearch.locationInputField,
                  selectedLocation = _props$advancedSearch.selectedLocation,
                  locationItems = _props$advancedSearch.locationItems;

              var newAdvancedSearchBarProps = {};

              if (locationInputField && !selectedLocation) {
                if (locationItems && locationItems.length > 0) {
                  (0, _doctifyUtils.googleWrapper)(function () {
                    (0, _reactPlacesAutocomplete.geocodeByPlaceId)(locationItems[0].placeId).then(function (addresses) {
                      props.advancedSearchBarActions.onLocationSelected(addresses[0]);
                      props.autocompleteActions.clearLocationNearMe();
                      newAdvancedSearchBarProps.selectedLocation = (0, _dropdowns.transformSeletedLocation)(addresses[0]);
                      search(newAdvancedSearchBarProps);
                    }).catch(function (error) {
                      return console.trace(error);
                    });
                  });
                } else {
                  var _location = defaultData.googleLocations[0];
                  locationInputField.value = _location.formatted_address;
                  props.advancedSearchBarActions.onLocationSelected(_location);
                  props.autocompleteActions.clearLocationNearMe();
                  newAdvancedSearchBarProps.selectedLocation = (0, _dropdowns.transformSeletedLocation)(_location);
                  search(newAdvancedSearchBarProps);
                }
              } else {
                search();
              }
            },
            onKeywordTextChanged: function onKeywordTextChanged(text) {
              return props.onKeywordTextChanged(text, props.advancedSearchBar.searchType);
            },
            onKeywordSelected: function onKeywordSelected(keyword) {
              if (keyword.type === 'specialist') {
                _reactRouter.browserHistory.push('/specialist/' + keyword.uri_id);
              } else if (keyword.type === 'practice') {
                _reactRouter.browserHistory.push('/practice/' + keyword.uri_id);
              } else {
                (0, _utils.searchAndUpdate)(props.advancedSearchBarActions.onKeywordSelected, props.launchSearch, props, ['selectedKeyword', 'selectedPage'])(keyword);
              }
            },
            onLocationTextchanged: props.onLocationTextchanged,
            onLocationSelected: props.onLocationSelected,
            onGenderSelected: function onGenderSelected(gender) {
              return (0, _utils.searchAndUpdate)(props.advancedSearchBarActions.onGenderSelected, props.launchSearch, props, ['selectedGender', 'selectedPage'])(gender === props.advancedSearchBar.selectedGender ? null : gender);
            },
            onVideoConsultationSelected: function onVideoConsultationSelected(videoConsultation) {
              return (0, _utils.searchAndUpdate)(props.advancedSearchBarActions.onVideoConsultationSelected, props.launchSearch, props, ['videoConsultation', 'selectedPage'])(videoConsultation);
            },
            onWithinSelected: (0, _utils.searchAndUpdate)(props.advancedSearchBarActions.onWithinSelected, props.launchSearch, props, ['selectedWithin', 'selectedPage']),
            onInsurerSelected: (0, _utils.searchAndUpdate)(props.advancedSearchBarActions.onInsurerSelected, props.launchSearch, props, ['selectedInsurer', 'selectedPage']),
            onTimeFrameSelected: function onTimeFrameSelected(dates) {
              var timeFrame = dates[1].isSame(new _moment2.default.utc().add(14, 'days'), 'day') && 'twoWeeks' || dates[1].isSame(new _moment2.default.utc().add(7, 'days'), 'day') && 'thisWeek' || dates[0].isSame(new _moment2.default.utc().add(1, 'day'), 'day') && 'tomorrow' || dates[0].isSame(new _moment2.default.utc(), 'day') && 'today';
              (0, _utils.searchAndUpdate)(props.advancedSearchBarActions.onTimeFrameSelected, props.launchSearch, props, ['selectedDates', 'selectedTimeFrame', 'selectedPage'])(dates, timeFrame);
            },

            onLanguageSelected: (0, _utils.searchAndUpdate)(props.advancedSearchBarActions.onLanguageSelected, props.launchSearch, props, ['selectedLanguage', 'selectedPage']),
            onSortTypeSelected: (0, _utils.searchAndUpdate)(props.advancedSearchBarActions.onSortTypeSelected, props.launchSearch, props, ['selectedSortType', 'selectedPage']),
            onCalendarDateChange: function onCalendarDateChange(dates) {
              var timeFrame = dates[1].isSame(new _moment2.default.utc().add(14, 'days'), 'day') && 'twoWeeks' || dates[1].isSame(new _moment2.default.utc().add(7, 'days'), 'day') && 'thisWeek' || dates[0].isSame(new _moment2.default.utc().add(1, 'day'), 'day') && 'tomorrow' || dates[0].isSame(new _moment2.default.utc(), 'day') && 'today';
              (0, _utils.searchAndUpdate)(props.advancedSearchBarActions.onTimeFrameSelected, props.launchSearch, props, ['selectedDates', 'selectedTimeFrame', 'selectedPage'])(dates, timeFrame);
            },

            getLocationNearMe: props.getLocationNearMe,
            clearLocationNearMe: props.clearLocationNearMe,
            usingNearMe: props.autocomplete.usingNearMe,
            findingLocation: props.autocomplete.findingLocation
          }))
        ),
        _react2.default.createElement('div', { className: (props.location.query.search_type === _constants.SCANS || props.location.query.search_type === _constants.HEALTH_CHECK ? _style2.default.scansSearchBarBackground : _style2.default.searchBarBackground) + ' ' + _style2.default.topNavBackground }),
        props.results.loadingResults ? _react2.default.createElement(_loadingDots.LoadingDots, { centered: true }) : props.results.searchResults && props.results.searchResults.length && _react2.default.createElement(
          'div',
          { className: 'container-fluid no-padding' },
          _react2.default.createElement(
            'div',
            { className: 'row no-gutter' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-md-8' },
              _react2.default.createElement(_searchResults.SearchResults, (0, _extends3.default)({}, props.results, props.resultsActions, {
                onPageClicked: (0, _utils.searchAndUpdate)(props.resultsActions.onPageClicked, props.launchSearch, props, 'selectedPage'),
                results: props.results.searchResults,
                lastPage: (0, _parseInt2.default)(props.results.totalResults / _constants.PAGE_SIZE) + (props.results.totalResults % _constants.PAGE_SIZE === 0 ? 0 : 1),
                searchType: props.advancedSearchBar.searchType,
                onHover: typeof window !== 'undefined' && window.innerWidth > 767 ? props.resultsActions.onHover : null,
                selectedKeyword: props.advancedSearchBar && props.advancedSearchBar.selectedKeyword && props.advancedSearchBar.selectedKeyword.name || { name: props.advancedSearchBar.text || '' },
                specialtiesListing: props.listings.specialties,
                selectedHospitalListId: props.advancedSearchBar.selectedInsurer && props.advancedSearchBar.selectedInsurer.id
              }))
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-sm-4 map-container visible-md visible-lg ' + _style2.default.mapContainer + ' ' + (props.location.query.search_type === _constants.SCANS || props.location.query.search_type === _constants.HEALTH_CHECK ? _style2.default.mapContainerScan : ''),
                style: { top: pagePaddingTop }
              },
              _react2.default.createElement(
                'div',
                { className: _style2.default.map },

                /**
                 Once again, be sure we are in the browser.
                 **/
                typeof window !== 'undefined' && window.google ? _react2.default.createElement(_googleMaps2.default, (0, _extends3.default)({}, props.resultsActions, {
                  containerElement: _react2.default.createElement('div', { style: { height: '100%' } }),
                  mapElement: _react2.default.createElement('div', { style: { height: '100%' } }),
                  onMapLoad: _utils.noop,
                  onMapClick: _utils.noop,
                  markers: props.results.markers,
                  onMarkerRightClick: _utils.noop
                })) : void props.loadGoogleMaps()
              )
            )
          )
        ) || _react2.default.createElement(
          'div',
          { className: _style2.default.noResults },
          _react2.default.createElement(
            'h3',
            null,
            'No results found ',
            props.advancedSearchBar.selectedKeyword ? 'for "' + props.advancedSearchBar.selectedKeyword.name + '"' : null
          ),
          _react2.default.createElement(
            'p',
            null,
            'Please try your search again with different parameters'
          )
        )
      )
    );
  };

  return SearchPage;
}(_react2.default.Component);

SearchPage.displayName = 'SearchPage';

SearchPage.defaultProps = {};

var mapStateToProps = function mapStateToProps(state) {
  return {
    page: state.search.page,
    results: state.search.results,
    session: (0, _reduxSimpleAuth.getSessionData)(state),
    listings: state.global.listings,
    autocomplete: state.global.autocomplete,
    isAuthenticated: (0, _reduxSimpleAuth.getIsAuthenticated)(state),
    mobileSearchMenu: state.global.mobileSearchMenu,
    advancedSearchBar: state.search.advancedSearchBar,
    app: state.global.app
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    pageActions: (0, _redux.bindActionCreators)(pageActions, dispatch),
    resultsActions: (0, _redux.bindActionCreators)(_resultsActions.resultsActions, dispatch),
    sessionActions: (0, _redux.bindActionCreators)({ invalidateSession: _reduxSimpleAuth.invalidateSession }, dispatch),
    listingsActions: (0, _redux.bindActionCreators)(ListingsActions, dispatch),
    autocompleteActions: (0, _redux.bindActionCreators)(AutocompleteActions, dispatch),
    mobileSearchMenuActions: (0, _redux.bindActionCreators)(MobileSearchMenuActions, dispatch),
    advancedSearchBarActions: (0, _redux.bindActionCreators)(_advancedSearchBarActions.advancedSearchBarActions, dispatch),
    init: function init(props) {
      searchPageLoader.runOnce(dispatch, props).then(function (isFirstLoad) {
        isFirstLoad && props.pageActions.pageLoaded();
      });
    },
    mapUrlToProps: function mapUrlToProps(props) {
      if ((0, _utils.urlChanged)(props.location && props.location.search)) {
        (0, _doctifyUtils.googleWrapper)(function () {
          return (0, _doctifyUtils.searchQueryParser)(props.location.query, props.listings).then(function (_ref) {
            var query = _ref.query;

            props.onQueryStringParsed(query);
            dispatch(_advancedSearchBarActions.advancedSearchBarActions.onKeywordSelected(query.selectedKeyword || query.selectedHealthCheck));
            if (query.text && !(query.selectedKeyword || query.selectedHealthCheck)) {
              dispatch(_advancedSearchBarActions.advancedSearchBarActions.updateText(query.text));
            }
            dispatch(_resultsActions.resultsActions.updateResults((0, _utils.buildSearchParameters)((0, _extends3.default)({}, query, { listings: props.listings })), query.searchType, props.listings, query.network)).then(function (_ref2) {
              var searchResults = _ref2.search_results;

              if (searchResults) {
                searchResults.forEach(function (result) {
                  if ((result.isBmi || result.isRamsay || result.isSpire) && result.type === 'specialist') {
                    var parameters = {
                      startdate: query.selectedDates && query.selectedDates.length > 1 ? query.selectedDates[0].format('YYYY-MM-DD') : _moment2.default.utc().format('YYYY-MM-DD'),
                      enddate: query.selectedDates && query.selectedDates.length > 1 ? query.selectedDates[1].format('YYYY-MM-DD') : _moment2.default.utc().add(14, 'days').format('YYYY-MM-DD'),
                      group_by_date: true,
                      for_public_view: true
                    };
                    dispatch(_resultsActions.resultsActions.updateAvailabilities({
                      profileUrl: result.type + 's/' + result.uri_id,
                      id: result.id,
                      startDate: parameters.startdate
                    }, parameters));
                  }
                });
              }
            });
          });
        });
      }
    },
    onTimeFrameSelected: function onTimeFrameSelected(dates, timeframe) {
      dispatch(_advancedSearchBarActions.advancedSearchBarActions.onTimeFrameSelected(dates, timeframe));
    },
    onQueryStringParsed: function onQueryStringParsed(query) {
      dispatch(_advancedSearchBarActions.advancedSearchBarActions.onQueryStringParsed(query));
      dispatch(_resultsActions.resultsActions.updateSelectedPage(!isNaN((0, _parseInt2.default)(query.selectedPage)) ? (0, _parseInt2.default)(query.selectedPage) : undefined));
    },
    populateAvailability: function populateAvailability(ApiProfileUrl, id, searchProps) {
      var parameters = {
        startdate: searchProps.selectedDates && searchProps.selectedDates.length > 1 ? searchProps.selectedDates[0].format('YYYY-MM-DD') : _moment2.default.utc().format('YYYY-MM-DD'),
        enddate: searchProps.selectedDates && searchProps.selectedDates.length > 1 ? searchProps.selectedDates[1].format('YYYY-MM-DD') : _moment2.default.utc().add(14, 'days').format('YYYY-MM-DD'),
        group_by_date: true,
        for_public_view: true
      };
      dispatch(_resultsActions.resultsActions.updateAvailabilities(ApiProfileUrl, id, parameters));
    },
    launchSearch: function launchSearch(searchProps) {
      _reactRouter.browserHistory.push({ search: '?' + _querystring2.default.stringify((0, _utils.buildSearchString)(searchProps)), pathname: searchProps.route.path });
      // remove this updateResults, because we will have another one in mapUrlToProps after changing url string by browserHistory.push
      // dispatch(resultsActions.updateResults(buildSearchParameters(searchProps), searchProps.searchType, searchProps.listings))
      // 	.then(({ search_results: searchResults }) => {
      // 		if (searchResults) {
      // 			searchResults.forEach(result => {
      // 				if (result.has_booking && result.type === 'specialist') {
      // 					const parameters = {
      // 						startdate: searchProps.selectedDates && searchProps.selectedDates.length > 1 ? searchProps.selectedDates[0].format('YYYY-MM-DD') : Moment.utc().format('YYYY-MM-DD'),
      // 						enddate: searchProps.selectedDates && searchProps.selectedDates.length > 1 ? searchProps.selectedDates[1].format('YYYY-MM-DD') : Moment.utc().add(2, 'days').format('YYYY-MM-DD'),
      // 						group_by_date: true,
      // 						for_public_view: true
      // 					};
      // 					dispatch(resultsActions.updateAvailabilities({
      // 							profileUrl: `${ result.type }s/${ result.uri_id }`,
      // 							id: result.id,
      // 							startDate: parameters.startdate
      // 						},
      // 						parameters));
      // 				}
      // 			});
      // 		}
      // 	});
    },
    onMarkerClicked: function onMarkerClicked(marker) {
      dispatch(pageActions.onMarkerClicked(marker));
    },
    onMarkerClosed: function onMarkerClosed(marker) {
      dispatch(pageActions.onMarkerClosed(marker));
    },
    onHover: function onHover(index) {
      dispatch(pageActions.resultHover(index));
    },
    loadGoogleMaps: function loadGoogleMaps() {
      (0, _doctifyUtils.googleWrapper)(function () {
        return dispatch(pageActions.googleMapLoaded());
      });
    },
    onLocationTextchanged: (0, _debounce3.default)(function (text) {
      if (text.length > _constants.MIN_AUTOCOMPLETE_LENGTH) {
        (0, _doctifyUtils.googleWrapper)(function () {
          (0, _doctifyUtils.placesAutocomplete)(text).then(function (predictions) {
            return dispatch(_advancedSearchBarActions.advancedSearchBarActions.updateLocations(predictions || []));
          });
        });
      }
    }),
    onLocationSelected: function onLocationSelected(location) {
      (0, _doctifyUtils.googleWrapper)(function () {
        (0, _reactPlacesAutocomplete.geocodeByPlaceId)(location.placeId).then(function (addresses) {
          dispatch(_advancedSearchBarActions.advancedSearchBarActions.onLocationSelected(addresses[0]));
          dispatch(AutocompleteActions.clearLocationNearMe());
        });
      });
    },
    onKeywordTextChanged: (0, _debounce3.default)(function (text, type) {
      if (text.length > _constants.MIN_AUTOCOMPLETE_LENGTH) {
        dispatch(_advancedSearchBarActions.advancedSearchBarActions.onKeywordTextChanged({
          types: type === _constants.SCANS && 'scans' || type === _constants.HEALTH_CHECK && 'health_checks' || 'conditions,procedures,specialties,specialists',
          filter: text,
          records: 5
        }));
      } else {
        dispatch(_advancedSearchBarActions.advancedSearchBarActions.updateText(text));
      }
    }, _constants.DEBOUNCE_RATE, _constants.DEBOUNCE_OPTIONS),
    openMobileSearchMenu: function openMobileSearchMenu() {
      dispatch(MobileSearchMenuActions.openMobileSearchMenu());
    },
    getMobileKeywordAutocomplete: function getMobileKeywordAutocomplete(filter) {
      if (filter.trim().length > 1) {
        (0, _doctifyUtils.googleWrapper)(function () {
          dispatch(AutocompleteActions.getDirectoryAutocomplete(filter));
        });
      } else {
        dispatch(AutocompleteActions.clearDirectoryAutocomplete());
      }
    },
    getMobileHealthCheckAutocomplete: function getMobileHealthCheckAutocomplete(filter) {
      if (filter.trim().length > 1) {
        (0, _doctifyUtils.googleWrapper)(function () {
          dispatch(AutocompleteActions.getHealthChecksAutocomplete(filter));
        });
      } else {
        dispatch(AutocompleteActions.clearHealthChecksAutocomplete());
      }
    },
    getMobileScanAutocomplete: function getMobileScanAutocomplete(filter) {
      if (filter.trim().length > 1) {
        (0, _doctifyUtils.googleWrapper)(function () {
          dispatch(AutocompleteActions.getScansAutocomplete(filter));
        });
      } else {
        dispatch(AutocompleteActions.clearScansAutocomplete());
      }
    },
    getMobileLocationAutocomplete: function getMobileLocationAutocomplete(filter) {
      if (filter.trim().length > 1) {
        (0, _doctifyUtils.googleWrapper)(function () {
          dispatch(AutocompleteActions.getLocationAutocomplete(filter));
        });
      } else {
        dispatch(AutocompleteActions.clearLocationAutocomplete());
      }
    },
    getLocationNearMe: function getLocationNearMe() {
      return new _promise2.default(function (resolve, reject) {
        dispatch(AutocompleteActions.getLocationNearMe()).then(function () {
          dispatch(_advancedSearchBarActions.advancedSearchBarActions.resetLocation());
          resolve();
        }).catch(function () {
          reject();
        });
      });
    },
    clearLocationNearMe: function clearLocationNearMe() {
      dispatch(AutocompleteActions.clearLocationNearMe());
      dispatch(_advancedSearchBarActions.advancedSearchBarActions.resetLocation());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchPage);


// WEBPACK FOOTER //
// ./components/search-page/lib/components/search-page.js